import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ServiceParameterModel } from 'src/app/models/service-parameter-model';
import { ServiceParameterService } from 'src/app/services/service-parameter.service';

@Component({
  selector: 'app-service-parameter-edit',
  templateUrl: './service-parameter-edit.component.html',
  styleUrls: ['./service-parameter-edit.component.scss']
})
export class ServiceParameterEditComponent implements OnInit {
  public parameterId: number = 0;
  public serviceParameter: ServiceParameterModel = {
    id: 0,
    name: '',
    service: {
      id: 0,
      name: ''
    }
  };

  constructor(private _modal: NgbActiveModal,  private _toastService: ToastrService, private _serviceParameterService: ServiceParameterService) { }

  async ngOnInit(): Promise<void> {
    console.log(this.parameterId);
    if (this.parameterId !== 0) {
      this.serviceParameter = await this._serviceParameterService.GetServiceParameterById(this.parameterId);
    }
  }

  public close() {
    this._modal.close();
  }

  public async save(): Promise<void> {
    const result = await this._serviceParameterService.EditService(this.serviceParameter);
    if (result.success) {
      this._toastService.success('Service Parameter updated successfully','Updated');
      this.close();
    } else {
      this._toastService.error('Could not update service parameter','Error');
    }
    return;
  }

}
